function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 16a4 4 0 10-8 0 4 4 0 008 0zm-4 2a2 2 0 100-4 2 2 0 000 4zm-7.5-1a1 1 0 100-2 1 1 0 000 2zm-4 0a1 1 0 100-2 1 1 0 000 2zm-9.07-.42a.58.58 0 01.498.496l.458 4.528c.05.497.259.53.464.075l4.57-10.145c.205-.457.002-.66-.455-.454L.821 15.657c-.456.206-.422.414.076.464l4.534.458z",
    fill: "#212121",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/favourite/ic-favourite-location.svg";